/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SurveyQuestionsBlocksInnerQuestionsInnerOptionsInner } from './surveyQuestionsBlocksInnerQuestionsInnerOptionsInner';


export interface SurveyQuestionsBlocksInnerQuestionsInner { 
    /**
     * 
     */
    key: string;
    /**
     * 
     */
    type: SurveyQuestionsBlocksInnerQuestionsInner.TypeEnum;
    /**
     * 
     */
    label: string;
    /**
     * 
     */
    isRequired?: boolean;
    /**
     * 
     */
    options?: Array<SurveyQuestionsBlocksInnerQuestionsInnerOptionsInner>;
}
export namespace SurveyQuestionsBlocksInnerQuestionsInner {
    export type TypeEnum = 'radio-table' | 'textarea';
    export const TypeEnum = {
        RadioTable: 'radio-table' as TypeEnum,
        Textarea: 'textarea' as TypeEnum
    };
}


